import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/components/AuthProvider'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { Layout } from '@/components/layout/Layout'
import { LoginPage } from '@/pages/LoginPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { PackagesPage } from '@/pages/PackagesPage'
import { UsersPage } from '@/pages/UsersPage'
import { BusinessesPage } from '@/pages/BusinessesPage'
import { FeaturesPage } from '@/pages/FeaturesPage'
import { AnalyticsPage } from '@/pages/AnalyticsPage'
import { DocumentManagementPage } from '@/pages/DocumentManagementPage'
import { HelpPage } from '@/pages/HelpPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/packages" element={<PackagesPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/businesses" element={<BusinessesPage />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/documents" element={<DocumentManagementPage />} />
              <Route path="/help" element={<HelpPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
